import React, { useState, forwardRef, useEffect } from "react";

import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";

const UpdateRegistrationFeedbackModal = forwardRef((props, ref) => {
  //
  const [registrationFeedback, setRegistrationFeedback] = useState("");
  //
  useEffect(() => {
    setRegistrationFeedback(props?.student?.registration_feedback);
  }, [props]);

  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Message de l'école"
        serviceAPI={studentsAPI}
        id={props?.student?.id}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        data={{
          registration_feedback: registrationFeedback,
        }}
      >
        <InputTextarea value={registrationFeedback || ""} className="w-full" onChange={(e) => {
          setRegistrationFeedback(e.target.value);
        }} rows={5} autoResize />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationFeedbackModal;
